import { Button } from 'react-bootstrap';
import logoWhite from './logo_white.svg';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

const Login = () => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (!(location.pathname === '/login')) {
            navigate("/login");
        }
        
    }, []);

    const handleLogin = () => {
        // OIDC configuration
        const authorizationEndpoint = 'https://proxy.prod.erasmus.eduteams.org/OIDC/authorization'; // Updated endpoint
        const clientId = 'APP-A65FFBD1-025B-4944-90A8-6FEECFE386E9';
        // todo change to env var
        const redirectUri = window.location.hostname === "localhost" ? 'http://localhost:3000/authentication/callback' : 'http://ascola-dev02.it.auth.gr/authentication/callback';
        const responseType = 'code';
        const scope = 'openid profile email voperson_external_affiliation eduperson_entitlement';
        const codeChallengeMethod = 'S256';

        // Retrieve code verifier and code challenge from session storage
        const codeVerifier = sessionStorage.getItem('code_verifier');
        const codeChallenge = sessionStorage.getItem('code_challenge');
        localStorage.removeItem('access_token');

        if (codeVerifier && codeChallenge) {
            const state = generateRandomString(16);
            sessionStorage.setItem('auth_state', state);

            const authUrl = `${authorizationEndpoint}?response_type=${responseType}&client_id=${clientId}&redirect_uri=${encodeURIComponent(redirectUri)}&scope=${encodeURIComponent(scope)}&code_challenge=${encodeURIComponent(codeChallenge)}&code_challenge_method=${codeChallengeMethod}&state=${state}`;
            window.location.href = authUrl;
        } else {
            console.error('Code verifier or code challenge is missing.');
        }
    };

    const generateRandomString = (length) => {
        const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
        let result = '';
        for (let i = 0; i < length; i++) {
            result += charset.charAt(Math.floor(Math.random() * charset.length));
        }
        return result;
    };

    return (
      <>
        <img src={logoWhite} className="App-logo" alt="logo" style={{marginTop: 30}} />
        <div style={{marginTop: 130}}>Browse reviews and evaluate courses <br/>
of your mobility exchange.
       </div>
       <Button style={{marginTop: 130, borderRadius: 0}} className='login-button' onClick={handleLogin}>Log in with MyAcademicID</Button>
       <div style={{marginBottom: 80, fontSize: 16, textAlign: "center", marginTop: 10}}><span style={{width: "15%", margin: "auto", display: "block", textAlign: "center"}}>Your Evaluation is just a click away!</span> <br/>

<span style={{width: "25%", margin: "auto", display: "block"}}>The login options available to access the AsCOLA platform are the following:</span><br/>
<ul style={{width: "25%", margin: "auto", display: "block", textAlign: "left"}}>
<li>eduGAIN (your academic credentials)</li>
<li>eIDAS (national ID)</li>
<li>Google login</li></ul><br/>
<span style={{width: "25%", margin: "auto", display: "block"}}>Clicking on "Login with MyAcademicID" will lead you to the MyAcademicID platform that supports all three of the pathways. 
    After the authentication procedure you will be redirected to the AsCOLA platform, where you will be able to Evaluate your OLA courses and access existing Evaluations.</span>
</div>
      </>
    );
  };

  export default Login;
// import React from 'react';
// import { useNavigate } from 'react-router-dom';

// function Login() {
//     const navigate = useNavigate();

//     const handleLogin = () => {
//         // OIDC configuration
//         const authorizationEndpoint = 'https://proxy.prod.erasmus.eduteams.org/OIDC/authorization'; // Updated endpoint
//         const clientId = 'APP-A65FFBD1-025B-4944-90A8-6FEECFE386E9';
//         // todo change to env var
//         const redirectUri = 'http://localhost:3000/authentication/callback';
//         const responseType = 'code';
//         const scope = 'openid profile email voperson_external_affiliation eduperson_entitlement';
//         const codeChallengeMethod = 'S256';

//         // Retrieve code verifier and code challenge from session storage
//         const codeVerifier = sessionStorage.getItem('code_verifier');
//         const codeChallenge = sessionStorage.getItem('code_challenge');

//         if (codeVerifier && codeChallenge) {
//             const state = generateRandomString(16);
//             sessionStorage.setItem('auth_state', state);

//             const authUrl = `${authorizationEndpoint}?response_type=${responseType}&client_id=${clientId}&redirect_uri=${encodeURIComponent(redirectUri)}&scope=${encodeURIComponent(scope)}&code_challenge=${encodeURIComponent(codeChallenge)}&code_challenge_method=${codeChallengeMethod}&state=${state}`;
//             window.location.href = authUrl;
//         } else {
//             console.error('Code verifier or code challenge is missing.');
//         }
//     };

//     const generateRandomString = (length) => {
//         const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
//         let result = '';
//         for (let i = 0; i < length; i++) {
//             result += charset.charAt(Math.floor(Math.random() * charset.length));
//         }
//         return result;
//     };

//     return (
//       <div>
//           <h1>Login</h1>
//           <button onClick={handleLogin}>MyAcademicID Login</button>
//       </div>
//     );
// }

// export default Login;
